import React from "react";
import { useTranslation } from "react-i18next";

import GreyHeader from "../../../../shared/ui/GreyHeader";
import ZonesMapComponent from "../../component/smart/zones/ZonesMapComponent";

import '../../component/dump/menuComponents/menuComponents.sass';

export default function ZonesPage () {
    const { t } = useTranslation('translation', { keyPrefix: 'zonesPage' });

    return (
        <div className="zones-page">
            <GreyHeader
                title={t('titleZones')}
                hideSubtitle
            />
            <main className="main-content-block">
                <ZonesMapComponent />
            </main>
        </div>
    )
}
